import cn from 'classnames';
import { HTMLProps } from 'react';

interface LayoutContainerProps extends HTMLProps<HTMLDivElement> {
  noMarginLeft?: boolean;
  noMarginRight?: boolean;
}

export const LayoutContainer = ({ noMarginLeft, noMarginRight, children, className }: LayoutContainerProps) => (
  <div
    className={cn(
      {
        'max-lg:ml-[calc(100vw*0.04)] lg:ml-[calc(100vw*0.10)]': !noMarginLeft,
        'max-lg:mr-[calc(100vw*0.04)] lg:mr-[calc(100vw*0.10)]': !noMarginRight,
      },
      className
    )}>
    {children}
  </div>
);
